export default __webpack_public_path__ + "static/media/myntra-white.20920a32.svg";